<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
         <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Data Verification </strong>
                </v-toolbar-title>
            </v-toolbar>
            <!-- {{division_data}}
            {{parent_data}}
            {{learner_data}} -->
            <v-row dense>
                <v-col cols="12" sm="4" md="4">
                        <v-switch v-model="no_div" @change="no_parent=false;no_stud=false" label="Student with no division "></v-switch>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-switch v-model="no_parent" @change="no_div=false;no_stud=false" label="Student without parent"></v-switch>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-switch v-model="no_stud" @change="no_div=false;no_parent=false" label="Parents without student"></v-switch>
                </v-col>
            </v-row>
            <v-data-table v-if="no_div && division_data!=''" :headers="headers" :items="division_data" dense sort-by="" class="elevation-1 mytable" :search="search">
               <template v-slot:top>
                <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Student with no division </strong>
                </v-toolbar-title>
            </v-toolbar><br>
               </template>
             </v-data-table>
            <v-data-table v-if="no_parent && learner_data!=''" :headers="headers" :items="learner_data" dense sort-by="" class="elevation-1 mytable" :search="search"> 
                <template v-slot:top>
                <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Student without parent </strong>
                </v-toolbar-title>
            </v-toolbar><br>
                </template>
            </v-data-table>
            <v-data-table  v-if="no_stud && parent_data!=''" :headers="headers_parent" :items="parent_data" dense sort-by="" class="elevation-1 mytable" :search="search"> 
               <template v-slot:top>
                <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Parents without student </strong>
                </v-toolbar-title>
            </v-toolbar><br>
               </template>
               <template v-slot:item.isconfirmed="{ item }">
                    <span v-if="item.isconfirmed">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>
            </v-data-table>
         </v-card>
          <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
    import axios from "axios";
    export default {
        data: () => ({
        no_div:false,
        no_parent:false,
        no_stud:false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        division_data:[],
        parent_data:[],
        learner_data:[],
        overlay:false,
        headers: [
                { text: "Registration Number", value: "registration_number" },
                { text: "First Name", value: "fname" },
                { text: "Middle Name", value: "mname" },
                { text: "Last Name", value: "lname" },
                { text: "Full Name", value: "full_name" },
                { text: "Mobile No.", value: "mobile_no" },
                { text: "Personal Email", value: "personal_email" },
            ],
        headers_parent: [
                { text: "Mobile No.", value: "mobile_no" },
                { text: "Personal Email", value: "uid" },
                { text: "Isconfirmed", value: "isconfirmed" },
            ],
        }),
        mounted() {
            this.overlay = true
             axios
                .post("/Academics/dataVerification")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.division_data = res.data.division_data
                        this.parent_data=res.data.parent_data
                        this.learner_data=res.data.learner_data
                        this.overlay = false
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.overlay = false
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.overlay = false
                })
                .finally(() => {});
        },
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
          
        },
    };
</script>
<style>
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .flash {
   animation-name: flash;
    animation-duration: 0.9s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-play-state: running;
}

@keyframes flash {
    from {color: red;}
    to {color: white;}
}
</style>
